import React from "react";
import { Link, useParams } from "react-router-dom";
import useSWR from "swr";
import DownCat from "../components/DownCat";
import LanguageApi from "../components/Language";
const Products = () => {
  const {product} = LanguageApi();
  let params = useParams();
  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "products.php?link=" + params.categoriesName
  );
  if (error) return <div>failed to load</div>
  if (!data) return <div>loading...</div>
  return (
    <div className="products sbg">
      <div className="Products-title-area">
        <div className="products-title">
          <h1>{product}</h1>
        </div>
        <div className="products-title-button">
          <DownCat link={params.categoriesName} />
        </div>
      </div>
      <div className="product">
        <div className="products-area-s">
          {data ? data.map((post) => (
            <Link
              className="product-single"
              to={`/product/${post.product_link}`}
            >
              <div className="product-single">
                <div className="product-image">
                  <img src={process.env.REACT_APP_DEF_URL+post.product_img} alt="product" />
                </div>
                <div className="product-text">
                  <p style={{ marginBottom: "8px" }}>{post.product_name}</p>
                  <div className="product-feature">
                    <span>{post.product_future1}</span>
                    <span>{post.product_future2}</span>
                    <span>{post.product_future3}</span>
                  </div>
                </div>
              </div>
            </Link>
          )): "ürün bulunamadı"}
        </div>
      </div>
    </div>
  );
};

export default Products;
